<template>
  <van-popup v-model="show" get-container="#app" round>
    <div class="pop-outer">
      <div class="pop-header">
        在寝状态处理
        <div class="close-btn" @click="closePop">
          <van-icon name="cross" />
        </div>
      </div>
      <div class="dispose-form">
        <div class="dispose-form-item">
          <div class="form-label">
            处理时段：
          </div>
          <div class="form-content">
            <filterRadio v-model="timeType" :optionList="timeTypeList" tabLabel="showValue" tabValue="subValue" :checkOut="true" :flexWrap="true" @change="changeTimeType"></filterRadio>
            <span v-if="timeTypeList.length == 0">当前时间暂无可处理时段</span>
          </div>
        </div>
        <div class="dispose-form-item">
          <div class="form-label">
            在寝状态：
          </div>
          <div class="form-content">
            <van-radio-group v-model="form.dormStatus" direction="horizontal" class="aj-radio-circle">
              <van-radio :name="item.subValue" v-for="item in radioList.filter(item => item.subValue != 10 && item.subValue != 11)">{{ item.showValue }}</van-radio>
            </van-radio-group>
          </div>
        </div>
        <div class="dispose-form-item">
          <div class="form-label">
            处理原因：
          </div>
          <div class="form-content">
            <van-field v-model="form.reason" rows="1" :autosize="{ minHeight: 100 }" type="textarea" class="aj-textarea-input" maxlength="150" />
          </div>
        </div>
      </div>
      <div class="pop-button">
        <div class="pop-button-cancel" @click="closePop">取消</div>
        <div class="pop-button-confirm" @click="confirm">确定</div>
      </div>
    </div>
  </van-popup>
</template>

<script>
import filterRadio from './filterRadio.vue';
import moment from 'moment';
export default {
  components: { filterRadio },
  data() {
    return {
      timeTypeList: [],
      form: {
        dormStatus: null,
        reason: null
      },
      show: false,
      findDate: '',
      // 是否归寝信息
      timeType: [],
      infoTimeType: null,
      userId: '',
      dormOrganId:'',
      status: '',
      radioList: [],
      radioList2: [
        {
          showValue: '在寝',
          subValue: '0',
          timeType: []
        },
        {
          showValue: '不在寝',
          subValue: '1',
          timeType: []
        },
        {
          showValue: '正常归寝',
          subValue: '5',
          timeType: ['2', '4']
        },
        {
          showValue: '正常离寝',
          subValue: '6',
          timeType: ['1', '3']
        },
        {
          showValue: '晚归',
          subValue: '2',
          timeType: ['2', '4']
        },
        {
          showValue: '迟离',
          subValue: '7',
          timeType: ['1', '3']
        },
        {
          showValue: '未归',
          subValue: '3',
          timeType: ['2', '4']
        },
        {
          showValue: '未离',
          subValue: '8',
          timeType: ['1', '3']
        }
        // {
        //   showValue: '无识别记录',
        //   subValue: '9',
        //   timeType: []
        // }
      ]
    };
  },
  computed: {
    newRadioList() {
      return this.radioList2
        .filter(item => {
          // 获取当前时段可选状态
          if (this.timeType[0]) {
            return item.timeType.indexOf(this.timeType[0]) != -1;
          } else {
            return item.timeType.length == 0;
          }
        })
        .filter(item => {
          // 过滤当前人员正在的状态
          return item.subValue != this.status;
        });
    }
  },
  methods: {
    async open(data) {
      this.findDate = data.findDate;
      this.userId = data.userId;
      this.dormOrganId = data.dormOrganId
      // this.timeType = data.timeType;

      this.status = data.status;
      // this.show = true;
      this.form.dormStatus = null;
      this.form.reason = null;
      this.timeType = data.timeType ? [data.timeType] : [];
      this.infoTimeType = data.timeType;
      const loading = this.$toast.loading({
        duration: 0,
        message: '加载中',
        forbidClick: true,
        getContainer: '#app'
      });
      try {
        await this.getTimeTypeList();
        await this.getStatusList();
        this.show = true;
        loading.clear();
      } catch (e) {
        loading.clear();
        this.$toast.fail({ getContainer: '#app', message: e.msg });
      } finally {
      }
    },
    // 处理时段查询
    getTimeTypeList() {
      return new Promise((resolve, reject) => {
        this.axios
          .post(`student-consumer/api/dormInoutTime/findUserSignDormTimeType`, {
            findDate: this.findDate,
            userId: this.userId
            // timeType: this.timeType
          })
          .then(res => {
            if (res.code == 200) {
              this.timeTypeList = res.data;
              resolve(res);
            } else {
              reject(res);
            }
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    // 在寝状态查询
    getStatusList() {
      return new Promise((resolve, reject) => {
        this.axios
          .post(`student-consumer/api/dormInoutTime/findSignStatus`, {
            findDate: this.findDate,
            userId: this.userId,
            dormOrganId:this.dormOrganId,
            timeType: this.timeType[0]
          })
          .then(res => {
            if (res.code == 200) {
              this.radioList = res.data
                ? res.data.filter(item => {
                    // return item.subValue != this.status;

                    if ((this.infoTimeType === undefined || this.infoTimeType === null) && (this.timeType[0] === undefined || this.timeType[0] === null)) {
                      return item.subValue != this.status;
                    } else if (this.infoTimeType == this.timeType[0]) {
                      return item.subValue != this.status;
                    } else {
                      return true;
                    }
                  })
                : [];
                
              resolve(res);
            } else {
              reject(res);
            }
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    changeTimeType(e) {
      this.form.dormStatus = null;
      this.getStatusList();
    },
    closePop() {
      this.show = false;
    },
    confirm() {
      if (!this.form.dormStatus) {
        return this.$toast.fail({ getContainer: '#app', message: '请选择在寝状态' });
      }
      const loadingToast = this.$toast.loading({
        duration: 0,
        message: '处理中...',
        forbidClick: true,
        getContainer: '#app'
      });
      let singDate = '';
      let rightDate = moment().format('HH:mm:ss');
      singDate = `${this.findDate} ${rightDate}`;
      this.axios
        .post(`student-consumer/nonInductive/attendance/dormSignInPlatform`, {
          ...this.form,
          signDate: singDate,
          userId: this.userId,
          dormOrganId:this.dormOrganId,
          timeType: this.timeType[0]
        })
        .then(res => {
          if (res.code == 200) {
            loadingToast.clear();
            this.$toast.success({ getContainer: '#app', message: '处理成功' });
            setTimeout(() => {
              this.closePop();
              this.$emit('confirm', 'refresh');
            }, 2000);
            // this.closePop();
            // this.$emit('confirm', 'refresh');
          } else {
            this.$toast.fail({ getContainer: '#app', message: res.msg });
          }
        })
        .catch(e => {
          this.$toast.fail({ getContainer: '#app', message: e.msg });
        });
    }
  }
};
</script>

<style lang="scss" scoped>
@import url('./loading.scss');
.pop-outer {
  color: #333;
  padding: 0 1.5rem;
  padding-bottom: 2rem;
  width: 90vw;
  position: relative;
  font-size: 0.875rem;
  background: url('./popinfo-bg.png');
  background-size: 100% 100%;

  .pop-header {
    padding: 1rem 0 0.7rem 0;
    text-align: center;
    position: relative;
    font-size: 1rem;
    font-weight: bold;
    .close-btn {
      position: absolute;
      color: #999999;
      right: -0.5rem;
      top: 1rem;
      font-size: 1rem;
    }
  }
  .pop-button {
    margin-top: 1rem;
    display: flex;
    justify-content: space-around;
    & > div {
      padding: 0.5rem 2rem;
      border-radius: 2rem;
    }
    .pop-button-cancel {
      background-color: #e0e8f6;
    }
    .pop-button-confirm {
      background-color: #1989fa;
      color: #fff;
    }
  }
}
.dispose-form-item {
  display: flex;
  & + & {
    margin-top: 0.5rem;
  }
  .form-label {
    text-align: right;
    padding-right: 0.5rem;
    padding-top: 0.1rem;
    color: #666666ff;
  }
  .form-content {
    flex: 1;
  }
}
::v-deep.aj-radio-circle {
  // background-color: red;
  .van-radio {
    margin-bottom: 0.5rem;
    .van-radio__icon {
      display: flex;
      align-items: center;
      .van-icon {
        background-color: #fff;
        height: 0.8em;
        width: 0.8em;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
    .van-radio__icon.van-radio__icon--checked {
      .van-icon {
        &::before {
          display: none;
        }
        &::after {
          display: block;
          content: '';
          width: 50%;
          height: 50%;
          background-color: #1989fa;
          border-radius: 100%;
        }
      }
    }
  }
}
::v-deep.aj-textarea-input {
  border: 1px solid #ccc;
  &.van-cell {
    padding: 0.25rem 0.5rem;
  }
}
</style>
